<template>
  <div></div>
</template>
<script>
import { isMobile } from '@/utils/utils'
let recursionNumber30 = 0
function init() {
  if (
    typeof window.WeixinJSBridge == 'object' &&
    typeof window.WeixinJSBridge.invoke == 'function'
  ) {
    handleFontSize()
  } else {
    if (window.WeixinJSBridge) {
      handleFontSize()
    } else if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize)
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
    }
  }

  function handleFontSize() {
    // 超过30次，停止递归
    if (recursionNumber30 > 30) {
      return
    }
    if (!window.WeixinJSBridge) {
      recursionNumber30++
      setTimeout(handleFontSize, 1000)
      return
    }
    // 设置网页字体为默认大小
    window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
    // 重写设置网页字体大小的事件
    window.WeixinJSBridge.on('menu:setfont', function () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
    })
  }
}
export default {
  name: 'CouponScene',
  data() {
    return {}
  },
  mounted() {
    if (isMobile('android')) {
      init()
    }
  },
}
</script>
<style lang="scss">
body {
  // ios禁止老人机放大字体
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>
